import { render, staticRenderFns } from "./sound2.vue?vue&type=template&id=a563ba98&scoped=true&"
import script from "./sound2.vue?vue&type=script&lang=js&"
export * from "./sound2.vue?vue&type=script&lang=js&"
import style0 from "./sound2.vue?vue&type=style&index=0&id=a563ba98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a563ba98",
  null
  
)

export default component.exports